import { isDevMode } from '@angular/core';

import { readEnvelope, SchemaRootResolver } from './schema-root';

/** `$state` — the envelope of the state the place bound, the one way to reach its `status` or its `error`. */
export const stateRoot: SchemaRootResolver = {
  resolve(address, scope) {
    const state = scope.state();

    if (address.keys.length === 0) {
      return state;
    }

    if (state === undefined) {
      reportMissingState(address.text);

      return undefined;
    }

    return readEnvelope(address, state);
  },

  dataOf: (keys) => (keys[0] === 'data' ? { from: 'node', keys: keys.slice(1) } : null),
};

function reportMissingState(text: string): void {
  if (isDevMode()) {
    console.warn(
      `Schema address "${text}" names "$state", but no state reached this node, so it resolves to nothing. ` +
        `Whatever renders it binds no [state]; $source reads the data source the node lives in without one.`
    );
  }
}
